if ($('#navigation-1 span[itemprop="name"]').text() === translation('navodaNaPestovani')) {
    $('body').addClass('navodaNaPestovani');
    function addReadMoreBtn() {
        $('.news-item').each(function () {
            var $item = $(this);
            var link = $item.find('a.title').attr('href');
            if ($item.find('.read-more').length) return;

            if (link) {
                $item.find('.description').append(
                    $('<a>', {
                        href: link,
                        text: translation('precistClanek'),
                        class: 'read-more'
                    })
                );
            }
        });
    }

    $(document).ready(function () {
        addReadMoreBtn();
    });

    document.addEventListener('ShoptetPagePaginationUsed', function () {
        document.addEventListener('ShoptetDOMPageContentLoaded', function handler() {
            addReadMoreBtn();
            document.removeEventListener('ShoptetDOMPageContentLoaded', handler);
        });
    });

}